import { useCallback, useState } from "react";

type UseDocumentAction = (value: string, expires?: string) => void;

const useDocumentCookie = (cookieName: string): [string, UseDocumentAction] => {
    const [cookie, setCookie] = useState(getCookie(cookieName));
    const setCookieValue = useCallback(
        (value: string, expires = "Fri, 31 Dec 9999 23:59:59 GMT"): void => {
            if (typeof value !== "string") {
                console.error("Cookie value must be a string");
                return;
            }
            setCookie(value);
            document.cookie = `${cookieName}=${value}; expires=${expires}; path=/`;
        },
        [cookieName]
    );

    function getCookie(name: string) {
        const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
        if (!matches) {
            return "";
        }
        return decodeURIComponent(matches[1]);
    }

    return [cookie, setCookieValue];
};

export { useDocumentCookie };
